import React from 'react';
import Proptypes from 'prop-types';
import { getFirContentByModelId, getFitContentByModelId } from './IORequests';
import _ from 'lodash';
import { FITTING_METHOD_FIR, FITTING_METHOD_FIT } from '../../../constants/saxs';

/** React conainer which is used to get fitting data to be plotted in abinitio Panel */
class SaxsAbInitioFittingDataContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
            fetched: false,
            fittingData: null,  // this will contain unparsed csv data
            subtraction: null
        }

        this.getFittingData = this.getFittingData.bind(this);
    }
    render() {
        if (this.props.subtraction && !_.isEqual(this.props.subtraction, this.state.subtraction)) {
            this.getFittingData();
        }

        return this.props.children(this.state.fittingData)
    }

    getFittingData() {
        const onSuccess = (response) => {
            /* response has the following structure:
            sExp  |  iExp |  Err | iFit(+Const) | Chi^2=   0.765
            0.919201E-02   0.160242E+02   0.412676E+00   0.165888E+02
            0.966330E-02   0.166164E+02   0.380589E+00   0.165777E+02
            0.101346E-01   0.164656E+02   0.333730E+00   0.165661E+02
            0.106059E-01   0.163215E+02   0.340836E+00   0.165539E+02
            */

            this.setState({
                fetching: false,
                fetched: true,
                fittingData: response.data,
                subtraction: this.props.subtraction
            });
        }

        const onError = (error) => {
            this.setState({
                error: error,
                fetching: false,
                fetched: false,
                subtraction: this.props.subtraction
            });
        }
        if (this.props.fittingMethod === FITTING_METHOD_FIR) {
            getFirContentByModelId(this.props.token, this.props.proposal, this.props.subtraction.subtractionId, this.props.subtraction.abInitioModels[0].shapeDeterminationModel.modelId, onSuccess, onError);
        } else if (this.props.fittingMethod === FITTING_METHOD_FIT) {
            getFitContentByModelId(this.props.token, this.props.proposal, this.props.subtraction.subtractionId, this.props.subtraction.abInitioModels[0].shapeDeterminationModel.modelId, onSuccess, onError);
        }

    }
}

export default SaxsAbInitioFittingDataContainer;

SaxsAbInitioFittingDataContainer.proptypes = {
    /* Fitting method used*/
    fittingMethod: Proptypes.string.isRequired,
    /** proposal name */
    proposal: Proptypes.string,
    /* Subtraction object */
    subtraction: Proptypes.object,
    /** ispyb backend authentication token */
    token: Proptypes.string
}



// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsAbInitionFittingDataContainer.js